import { CSSResultGroup, html, TemplateResult } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import componentStyles from './idb-slide-card.css.lit';
import { classMap } from 'lit/directives/class-map.js';
import { IdbContentCard } from '../idb-content-card/idb-content-card';

/**
 * The IDB Course Card component.
 * @element idb-slide-card
 * @extends IDBContentCard
 * @see Events Card for similar styling
 */
@customElement('idb-slide-card')
export class SlideCard extends IdbContentCard {
  static styles: CSSResultGroup = [componentStyles];

  @property({ type: String, attribute: 'image-url' }) imageURL = '';
  @property({ type: String, attribute: 'image-link' }) imageLink = '';
  @property({ type: String, attribute: 'image-link-title' }) imageLinkTitle =
    '';
  @property({ type: String, attribute: 'video-id' }) videoID = '';

  render(): TemplateResult {
    const cardClasses = {
      card: true,
      [`outline-bg-${this.cardBackground}`]: this.cardBackground !== undefined,
    };

    return html`
      <div class="${classMap(cardClasses)}">
        ${
          this.videoID
            ? html`
            <div class="video-wrapper">
              <iframe src="https://www.youtube.com/embed/${this.videoID}" frameborder="0" allowfullscreen></iframe>
            </div>`
            : html`
            <a class="img-wrapper" href="${this.imageLink}" title="${this.imageLinkTitle}" target="_blank">
              <img src="${this.imageURL}" alt="Card Image" class="card-image">
            </a>`
        }
        <div class="card-body">
          <slot name="card-body"></slot>
        </div>
      </div>
    `;
  }
}
